<template>
    <div class="card-container">
        <v-row v-if="coach" @click="toCoachProfile" align="center">
            <v-col cols="3" class="pr-0">
                <div class="img-coach" :style="{ backgroundImage: `url('${coachImg}')` }"></div>
            </v-col>
            <v-col cols="9" class="p-relative">
                <div class="name-coach text-truncate">
                    {{ coach.name || $t("common.not_available_short") }}
                </div>
                <div class="sport-coach text-truncate">
                    {{ joinSports || $t("common.not_available_short") }}
                </div>
                <div class="description-coach text-truncate">
                    {{ coach.description || $t("common.not_available_short") }}
                </div>
                <div class="coach-stars">
                    <v-icon color="#99CC00" size="14">mdi-star-outline</v-icon>
                    {{ coachStars }}
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default {
    props: {
        coach: {
            type: Object,
            default: null,
        }
    },
    computed: {
        coachImg(vm = this) {
            return vm.coach?.avatar || require(`@/assets/img/logo.png`)
        },
        joinSports(vm = this) {
            return vm.coach?.sport_areas?.join(', ') || ''
        },
        coachStars(vm = this) {
            if (!vm.coach.rating) return '0'
            return Number(vm.coach.rating.stars).toFixed(1).replace('.0', '')
        },
        hasImg(vm = this) {
            return vm.coach.avatar
        }
    },
    methods: {
        toCoachProfile() {
            const vm = this
            vm.$router.push({name: 'student.coach-profile', params: {uid: vm.coach.objectID}})
        }
    }
}
</script>

<style scoped>

.card-container {
    border: thin solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
}

.name-coach {
    font-size: 15px;
    font-weight: bold;
    color: #707070;
    width: 85%;
}

.sport-coach {
    font-size: 12px;
    color: #707070;
    margin-top: 4px;
    margin-bottom: 4px;
}

.description-coach {
    font-size: 10px;
    color: #707070;
}

.img-coach {
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 0 0 4px;
    background-color: rgba(1, 55, 46, 0.07);
    height: 100px;
    border-right: thin solid rgba(0, 0, 0, 0.12);
}

.coach-stars {
    position: absolute;
    right: 20px;
    top: 12px;
    font-size: 14px;
    color: #99CC00;
}

</style>